module.exports = "/static/assets/e54636902d4b5c31f52aa582c0bac0f0.gif";